import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { laptopAndBelow } from '@sorare/core/src/style/mediaQuery';

import { AnyPlayerStatsIcon } from 'components/player/AnyPlayerStatsIcon';

import { AnyStatsIconCell_anyPlayer } from './__generated__/index.graphql';

const Wrapper = styled.div`
  width: var(--player-stats-icon-width);
  flex-shrink: 0;
  @media ${laptopAndBelow} {
    display: none;
  }
`;

type Props = {
  anyPlayer: AnyStatsIconCell_anyPlayer;
  onStatsClick: () => void;
};

export const AnyStatsIconCell = ({ anyPlayer, onStatsClick }: Props) => {
  return (
    <Wrapper>
      <AnyPlayerStatsIcon player={anyPlayer} onClick={onStatsClick} />
    </Wrapper>
  );
};

AnyStatsIconCell.fragments = {
  anyPlayer: gql`
    fragment AnyStatsIconCell_anyPlayer on AnyPlayerInterface {
      slug
      ...AnyPlayerStatsIcon_anyPlayer
    }
    ${AnyPlayerStatsIcon.fragments.anyPlayer}
  ` as TypedDocumentNode<AnyStatsIconCell_anyPlayer>,
};
